import gql from 'graphql-tag';

export default gql`
  query GetAllUsers($searchTerm: String, $filterTerm: UserRole) {
    users(
      orderBy: updatedAt_DESC
      where: {
        role: $filterTerm
        role_not_in: [VENDOR_ADMIN, VENDOR_USER]
        OR: [{ email_contains: $searchTerm }, { firstName_contains: $searchTerm }, { lastName_contains: $searchTerm }]
      }
    ) {
      createdAt
      id
      updatedAt
      email
      firstName
      lastName
      authCode
      status
      role
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllUsers.ts